import { TreeItemType } from '@api';
import { FileTreeContextMenu, formatDate, ItemInstanceType } from '@common';
import { Group, Input, Menu, Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ContextMenuActionIcon } from '../../common';
import { FileIcon } from './components';
import { formatFileSize } from './helpers';

type FileItemPropsType = {
  item: ItemInstanceType<TreeItemType>;
  canWrite: boolean;
  onDelete: (item: TreeItemType) => void;
  isHovered: boolean;
};

export const FileItem: React.FC<FileItemPropsType> = ({
  item,
  canWrite,
  onDelete,
  isHovered,
}) => {
  const { t } = useTranslation();
  const { lastModified, size, downloadUrl, name, fileType } =
    item.getItemData();
  const date = formatDate(lastModified);
  const formattedSize = size ? formatFileSize(size) : t('NO_DATA_PLACEHOLDER');
  const isRenaming = item.isRenaming();

  const downloadItem = () => {
    if (!downloadUrl) return;
    window.open(downloadUrl, '_blank');
  };

  const isEditable = canWrite && item.getItemData().isEditable;

  return (
    <>
      <Table.Td pl={item.getItemMeta().level * 30}>
        <Group gap="xs" id={item.getId()} p={5}>
          <FileIcon fileType={fileType} />
          {isRenaming ? (
            <Input {...item.getRenameInputProps()} size="xs" />
          ) : (
            <Text>{name}</Text>
          )}
        </Group>
      </Table.Td>
      <Table.Td>
        <Text>{date}</Text>
      </Table.Td>
      <Table.Td>
        <Text>{formattedSize}</Text>
      </Table.Td>
      <Table.Td>
        <Menu>
          <ContextMenuActionIcon visible={isHovered} />
          <Menu.Dropdown>
            <FileTreeContextMenu.Download onClick={downloadItem} />
            {isEditable && (
              <>
                <FileTreeContextMenu.Rename
                  onClick={() => item.startRenaming()}
                />
                <FileTreeContextMenu.Divider />
                <FileTreeContextMenu.Delete
                  onClick={() => onDelete(item.getItemData())}
                />
              </>
            )}
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </>
  );
};
